module.exports = __webpack_public_path__ + "static/media/1007137.d7692f01.jpg";